import { BaseClass, ObjectProperties } from "../core/classes/BaseClass.class";

export class HaulRate extends BaseClass{

    public quarry:Quarry
    public distance:DistanceRate|null
    public zone:ZoneRate|null
    public deliveryRate:number|null
    public formatedDeliveryRate:string|null
    public distanceMiles:number|null
    public distanceKm:number|null
    public hasRate:number|null

    constructor(data?:{quarry:Quarry, distance:DistanceRate|null, zone:ZoneRate|null, deliveryRate:number|null, formatedDeliveryRate:string|null, distanceMiles:number|null, distanceKm:number|null, hasRate:number|null}){
        super();
        this.quarry = new Quarry();
        this.distance = null;
        this.zone = null;
        this.deliveryRate = null;
        this.formatedDeliveryRate = null
        this.distanceMiles = null;
        this.distanceKm = null;
        this.hasRate = null;

        if(typeof data !== "undefined" && data !== null){
            this.init(data);
        }
    }

    override init(data: {quarry:Quarry,distance:DistanceRate|null,zone:ZoneRate|null,deliveryRate:number|null,distanceMiles:number|null,distanceKm:number|null,hasRate:number|null}): void {
        this.quarry = data.quarry;
        this.distance = data.distance;
        this.zone = data.zone;
        this.deliveryRate = data.deliveryRate === null ? 9999 : data.deliveryRate;
        this.formatedDeliveryRate = data.deliveryRate === null ? "" : this.formatNumber(data.deliveryRate,0,2)
        this.distanceMiles = data.distanceMiles;
        this.distanceKm = data.distanceKm;
        this.hasRate = data.hasRate;
    }
    override getCompareObjectKeys(): ObjectProperties[] {
        throw new Error("Method not implemented.");
    }
}


export class Quarry extends BaseClass{
    public id:number;
    public code:string;
    public name:string;
    public address:string;
    public haulRateType:string
    public haulRate:number|null

    constructor(data?:{id:number,code:string,name:string,address:string,haulRateType:string,haulRate:number|null}){
        super();
        this.id = -1;
        this.code = "";
        this.name = "";
        this.address = "";
        this.haulRateType = ""
        this.haulRate = null;

        if(typeof data !== "undefined" && data !== null){
            this.init(data);
        }
    }

    override init(data: {id:number,code:string,name:string,address:string,haulRateType:string,haulRate:number|null}): void {
        this.id = data.id;
        this.code = data.code;
        this.name = data.name;
        this.address = data.address;
        this.haulRateType = data.haulRateType;
        this.haulRate = data.haulRate;
    }
    override getCompareObjectKeys(): ObjectProperties[] {
        throw new Error("Method not implemented.");
    }
}

export class DistanceRate extends BaseClass{
    public id:number;
    public quarryId:number;
    public name:string;
    public maxMileDistance:number;
    public haulRate:number;

    constructor(data?:{id:number, quarryId:number,name:string,maxMileDistance:number,haulRate:number}){
        super();

        this.id = -1;
        this.quarryId = -1;
        this.name = "";
        this.maxMileDistance = 0;
        this.haulRate = 0;

        if(typeof data !== "undefined" && data !== null){
            this.init(data);
        }
    }

    override init(data:{id:number, quarryId:number,name:string,maxMileDistance:number,haulRate:number}): void {
        this.id = data.id;
        this.quarryId = data.quarryId;
        this.name = data.name;
        this.maxMileDistance = data.maxMileDistance;
        this.haulRate = data.haulRate;
    }

    override getCompareObjectKeys(): ObjectProperties[] {
        throw new Error("Method not implemented.");
    }
}

export class ZoneRate extends BaseClass{

    public id:number;
    public quarryId:number;
    public name:string;
    public description:string;
    public haulRate:number;

    constructor(data?:{id:number, quarryId:number,name:string,description:string,haulRate:number}){
        super();

        this.id = -1;
        this.quarryId = -1;
        this.name = "";
        this.description = "";
        this.haulRate = 0;

        if(typeof data !== "undefined" && data !== null){
            this.init(data);
        }
    }

    override init(data:{id:number, quarryId:number,name:string,description:string,haulRate:number}): void {
        this.id = data.id;
        this.quarryId = data.quarryId;
        this.name = data.name;
        this.description = data.description;
        this.haulRate = data.haulRate;
    }

    override getCompareObjectKeys(): ObjectProperties[] {
        throw new Error("Method not implemented.");
    }

}